// eslint-disable-next-line import/no-extraneous-dependencies
const isEmpty = require('lodash/isEmpty');
/**
 * Display a sentence with the desired number of words
 * @param {string} str sentence from html tag
 * @param {number} num - number of words to show
 * @param {string} elipsis - sign after sentence
 * @returns string
 */
export const stringFormatter = (str, num, elipsis) => {
  if (str) {
    const wordCount = str.split(' ');
    if (wordCount.length > num) {
      const sentence = wordCount.slice(0, num).join(' ');
      return `${sentence} ${elipsis || '[...]'}`;
    }
    return str;
  }
  return '';
};

/**
 * Format query string
 * @param {string} url - url from component
 * @param {object} params - query string object key value pair
 * @returns string
 */
export const urlParamsFormatter = (url, params) => {
  const paramsFormatter = Object.keys(params).map((key) => {
    if (!params[key]) {
      return '';
    }
    return `${key}=${params[key]}`;
  }).filter((value) => value);
  let formated = null;
  if (paramsFormatter.length > 1) {
    formated = paramsFormatter.join('&');
  } else {
    formated = paramsFormatter.toString();
  }
  return formated ? `${url}?${formated}` : url;
};

/**
 *  Build URL with a query string and append it to the URL.
 */
export const updateUrlWithParameters = (parameters) => {
  // Remove empty or default object values.
  Object.keys(parameters).forEach((key) => {
    if (
      parameters[key] === ''
          || parameters[key] === undefined
          || parameters[key] === 'all'
          || parameters.page === 1
    ) {
      // eslint-disable-next-line no-param-reassign
      delete parameters[key];
    }
  });

  if (window.history.replaceState) {
    let newUrl = `${window.location.href.split('?')[0]
    }?${
      // eslint-disable-next-line no-undef
      decodeURIComponent($.param(parameters))}`;

    // If no parameters let the url be initial URL.
    if (isEmpty(parameters)) {
      // eslint-disable-next-line prefer-destructuring
      newUrl = window.location.href.split('?')[0];
    }

    window.history.replaceState({ path: newUrl }, '', newUrl);
  }
};
